import { useEffect, useState } from "react";
import { getDeviceTier } from "@/lib/deviceTier";

export function useDeviceTier() {
  const [tier, setTier] = useState(() => getDeviceTier());

  useEffect(() => {
    const onChange = (e) => {
      const next = e?.detail?.tier || getDeviceTier();
      setTier(next);
    };
    window.addEventListener("reshet-device-tier", onChange);
    return () => window.removeEventListener("reshet-device-tier", onChange);
  }, []);

  return {
    tier,
    isConstrained: tier === "constrained",
    isModern: tier === "modern",
  };
}
